import * as types from '../mutation-types'
import ColumnsData from "../../plugins/columns_data";
import store from "../index";
import UsersApi from "../../api/users";

// state
export const state = {
    requests: [],
    credit_department: [],
    sales_department: [],
    operations_cash: [],
    operations_bank: [],
    operations_cars: [],
    car_warehouse: [],
    deals: [],
    report_sales: [],
    report_requests: [],
    report_requests_regions: [],
    report_departments_sales: [],
    report_departments_credit: [],
    report_departments_call_center: [],
    report_departments_call_center_calls: [],
    report_agency: [],
    report_agency2: [],
    report_banks: [],
    affiliate_sales: [],
    report_affiliate_sales: [],
    additional_agreements: [],
    calls: [],
    newed: {},
};

// getters
export const getters = {
    requests: state => state.requests,
    credit_department(state) {
        let banks_slugs = _.map(_.filter(ColumnsData['credit_department']().all, ['type', 'bank']), 'id');
        let allowed_banks_slugs = store.getters['auth/user'].allowed_banks_slugs;
        return _.filter(state.credit_department, function (slug) {
            if (banks_slugs.includes(slug) && !allowed_banks_slugs.includes(slug)) {
                return false;
            }
            return true;
        });
    },
    sales_department: state => state.sales_department,
    operations_cash: state => state.operations_cash,
    operations_bank: state => state.operations_bank,
    operations_cars: state => state.operations_cars,
    car_warehouse: state => state.car_warehouse,
    deals: state => state.deals,
    report_sales: state => state.report_sales,
    report_requests: state => state.report_requests,
    report_requests_regions: state => state.report_requests_regions,
    report_departments_sales: state => state.report_departments_sales,
    report_departments_credit: state => state.report_departments_credit,
    report_departments_call_center: state => state.report_departments_call_center,
    report_departments_call_center_calls: state => state.report_departments_call_center_calls,
    report_agency: state => state.report_agency,
    report_agency2: state => state.report_agency2,
    report_banks: state => state.report_banks,
    affiliate_sales: state => state.affiliate_sales,
    report_affiliate_sales: state => state.report_affiliate_sales,
    additional_agreements: state => state.additional_agreements,
    calls: state => state.calls,
};

// mutations
export const mutations = {
    [types.COLUMNS_SET] (state, data) {
        state[data.type] = data.columns;
        let storage = localStorage.getItem('columns');
        storage = storage === null ? {} : JSON.parse(storage);
        storage[data.type] = data.columns;
        localStorage.setItem('columns', JSON.stringify(storage));
        if (data.putDB) UsersApi.putInterfaceSettings('columns', storage);

        let storage_knows = localStorage.getItem('columns_knows');
        storage_knows = storage_knows === null ? {} : JSON.parse(storage_knows);
        storage_knows[data.type] = storage_knows[data.type] ? _.uniq(storage_knows[data.type].concat(data.columns)) : data.columns;
        localStorage.setItem('columns_knows', JSON.stringify(storage_knows));
        if (data.putDB) UsersApi.putInterfaceSettings('columns_knows', storage_knows);
    },
    [types.COLUMNS_PUT_DB] (state) {
        let storage = localStorage.getItem('columns');
        storage = storage === null ? {} : JSON.parse(storage);
        UsersApi.putInterfaceSettings('columns', storage);

        let storage_knows = localStorage.getItem('columns_knows');
        storage_knows = storage_knows === null ? {} : JSON.parse(storage_knows);
        UsersApi.putInterfaceSettings('columns_knows', storage_knows);
    },
};

// actions
export const actions = {
    set(context, data) {
        data.putDB = true;
        context.commit(types.COLUMNS_SET, data);
    },
    load(context) {
        let db_settings = store.getters['auth/user'].interface_settings;
        let storage = db_settings && db_settings['columns'] ? db_settings['columns'] : localStorage.getItem('columns');
        if (!storage) storage = {}
        if (typeof storage === 'string') storage = JSON.parse(storage);
        for (let key in context.getters) {
            if (!storage[key]) {
                storage[key] = ColumnsData[key]().default.map(item => item.id)
            }
            context.commit(types.COLUMNS_SET, {type: key, columns: storage[key], putDB: false})
        }
        localStorage.setItem('columns', JSON.stringify(storage));

        // Новые колонки
        let storage_knows = db_settings && db_settings['columns_knows'] ? db_settings['columns_knows'] : localStorage.getItem('columns_knows');
        if (!storage_knows) storage_knows = {}
        if (typeof storage_knows === 'string') storage_knows = JSON.parse(storage_knows);

        for (let key in context.getters) {
            if (storage_knows[key] && ColumnsData[key]().added) {
                // Список новых колонок
                let diff_columns = _.difference(ColumnsData[key]().added, storage_knows[key])
                // Добавляем новые колонки
                context.commit(types.COLUMNS_SET, {type: key, columns: _.uniq(diff_columns.concat(storage[key])), putDB: false})
                context.state.newed[key] = diff_columns;
            }
        }

        context.commit(types.COLUMNS_PUT_DB);
    }
};
